module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plain-banner"
  }, [_c('svg-icon', {
    staticClass: "plain-banner__icon icon icon--white",
    attrs: {
      "icon": "webkey-with-no-device"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "plain-banner__title title--general title--huge"
  }, [_vm._v("Device Not Found")]), _vm._v(" "), _c('div', {
    staticClass: "plain-banner__container"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3119996","hasScoped":false}!./app/components/device-not-found/template.html
// module id = 370
// module chunks = 0